module.exports = __webpack_public_path__ + "img/png.d945ca60.svg";